/**
 * CUSTOM
 * This code has been developed for this solution.
 */
import { ProfileQueryData } from "../../core/models/Profile";
import NetworkServiceFactory from "../../core/services/network/NetworkService";
import { DEFAULT_QUERY_DATA } from "../../core/services/network/NetworkTypes";
import { useProfilesContext } from "./ProfilesContext";

const useProfilesActions = () => {
  const { setProfilesResponseData, setProfilesLoading, setProfilesError } =
    useProfilesContext();

  const dispatchGetProfiles = async (
    query: ProfileQueryData = DEFAULT_QUERY_DATA()
  ) => {
    let cancelLoading = false;
    setTimeout(() => {
      if (!cancelLoading) {
        setProfilesLoading(true);
      }
    }, 400);
    const networkService = NetworkServiceFactory.shared;
    try {
      const data = await networkService.getUsersProfile(query);
      setProfilesResponseData(data);
      setProfilesError(undefined);
      return data;
    } catch (e: any) {
      setProfilesError(e);
    } finally {
      cancelLoading = true;
      setProfilesLoading(false);
    }
  };

  const dispatchCleanUsersProfileContext = () => {
    setProfilesResponseData(undefined);
    setProfilesError();
  };

  return {
    dispatchGetProfiles,
    dispatchCleanUsersProfileContext,
  };
};

export { useProfilesActions };
